var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5V4.3M6 0.5V4.3M1 8.1H19M3 2.4H17C18.1046 2.4 19 3.25066 19 4.3V17.6C19 18.6493 18.1046 19.5 17 19.5H3C1.89543 19.5 1 18.6493 1 17.6V4.3C1 3.25066 1.89543 2.4 3 2.4Z",
    stroke: "#50C878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCalendar);
export default __webpack_public_path__ + "static/media/green_calendar.4c57419fa9da4e5a9035e01f4695ece6.svg";
export { ForwardRef as ReactComponent };